import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { LayoutSwitchElement } from "../CustomComponents/LayoutSwitchElement";

/**
 * The payline element is used for hold payline special cases and handle payline behaviour on screen.
 * @class Symbol
 * @extends SwitchElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Payline extends LayoutSwitchElement {
    // base payline cases
    static CaseSelect: string = "SELECT";

    static CaseInit: string = "INIT";
    static CaseNormal: string = "NORMAL";
    static CaseNowin: string = "NOWIN";
    static CaseWin: string = "WIN";
    static CaseSingleCycle: string = "SINGLE_CYCLE";
    static CaseCycle: string = "CYCLE";
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Payline.ts
 **/